/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_Error_Web_Url_Missing1Inputs */

const vi_cmstools_error_web_url_missing1 = /** @type {(inputs: Cmstools_Error_Web_Url_Missing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa cấu hình địa chỉ website (SHOP_WEB_URL) nên chưa xem trước được — báo quản trị hệ thống.`)
};

/**

* @param {Cmstools_Error_Web_Url_Missing1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_error_web_url_missing1 = /** @type {((inputs?: Cmstools_Error_Web_Url_Missing1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_Error_Web_Url_Missing1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_error_web_url_missing1(inputs)
});
export { cmstools_error_web_url_missing1 as "cmsTools_error_web_url_missing" }